var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-complete"},[_c('h2',[_vm._v("送信完了しました。")]),_vm._v(" "),_c('p',[_vm._v("弊社よりメールを確認し、連絡いたしますのでしばらくお待ちください。")]),_vm._v(" "),_c('p',[_vm._v("※こちらより自動でお問い合わせ完了メールをお送りしています。届いていない場合はメールアドレスが間違っている可能性があります。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14ffaf82","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contactForm/thanksPage.vue
// module id = null
// module chunks = 